import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../routes';
import './Banner.scss';

function Banner({ square, forLawyer, forClient }) {
  return (
    <>
      {forLawyer && (
        <Link to={ROUTES.COMUNITY} className='Banner_link'>
          <div className='Banner'>
            <img
              src='/img/publicidad/background/logo.svg'
              className='Banner_logo'
              alt='logo'
            />
            <p className='Banner_title'>
              ¿No has encontrado a un abogado que se ajuste a tus necesidades?
            </p>
            <hr className='Banner_divider'/>
            <p className='Banner_subtitle'>
              Contáctanos, te ayudaremos<br/>a encontrarlo
            </p>
            <div className='Banner_button'>
              <p className='Banner_button-text'>
                Contactar
              </p>
            </div>
          </div>
        </Link>
      )}

      {forClient && (
        <Link to={ROUTES.SEARCH_LAWYER}>
          <img
            src='/img/publicidad/client/banner-cliente.jpg'
            alt='buscar abogado'
            style={{ position: 'sticky', top: 90 }}
          />
        </Link>
      )}
    </>
  );
}

export default Banner;
